import type { AssetReplacementCostFieldProps } from "./asset-replacement-cost-field.type";

import { Form } from "antd";
import { useTranslation } from "react-i18next";

import { TranslateCostSymbol } from "@/modules/translate";
import { InputNumber } from "@/ui/input-number";

const AssetReplacementCostField = ({
  inputProps,
  ...formItemProps
}: AssetReplacementCostFieldProps) => {
  const { t } = useTranslation();
  const label = t("asset:form.replacementCost.label");

  return (
    <Form.Item name="replacement_cost" label={label} {...formItemProps}>
      <InputNumber
        min={0}
        addonAfter={<TranslateCostSymbol />}
        placeholder={label}
        {...inputProps}
      />
    </Form.Item>
  );
};

export default AssetReplacementCostField;
